import { min, max, scaleLinear } from 'd3';
import _ from 'lodash';


const useGetScales = chartView => {
  const coordValX = node =>
    node.values[chartView[0] - 1];

  // svgs start at the top as zero so the Y values need to be flipped
  const coordValY = node =>
    node.values[chartView[1] - 1] * -1;

  const getScales = (dimensions, filteredData, isCenteredChart) => {
    let minX = min(filteredData.map(d => coordValX(d)));
    let maxX = max(filteredData.map(d => coordValX(d)));
    let minY = min(filteredData.map(d => coordValY(d)));
    let maxY = max(filteredData.map(d => coordValY(d)));

    if (isCenteredChart === true) {
      maxX = Math.max(Math.abs(minX), maxX);
      maxY = Math.max(Math.abs(minY), maxY);
      minX = maxX * -1;
      minY = maxY * -1;
    }

    // special case kludgy adjustments
    if (minY === 0 && maxY === 0) {
      minY = -0.0001;
      maxY = 0.0001;
    }
    if (minX === 0 && maxX === 0) {
      minX = -0.0001;
      maxX = 0.0001;
    }
    if (_.round(minY, 9) === _.round(maxY)) {
      // if thsre is no range then the chart won't draw
      maxY = Math.abs(maxY);
      minY = maxY * -1;
    }
    if (_.roundminX === maxX) {
      maxX = Math.abs(maxX);
      minX = maxX * -1;
    }
    // end special kludy addjustments

    // add padding (40%)
    minX *= 1.2;
    maxX *= 1.2;
    minY *= 1.4;
    maxY *= 1.4;

    const xScale = scaleLinear()
      .domain([minX, maxX])
      .range([0, dimensions.width]);
    const yScale = scaleLinear()
      .domain([minY, maxY])
      .range([0, dimensions.height]);

    return { xScale, yScale, minY, maxY, minX, maxX };
  };

  const getYBoundaryLimit = (yPos, yScale, minY, maxY, yPadding) => {
    const sMinY = yScale(minY);
    const sMaxY = yScale(maxY);
    const y = (yPos < sMinY - yPadding)
      ? sMinY - yPadding
      : (yPos > sMaxY + yPadding)
        ? sMaxY + yPadding
        : yPos;

    return y;
  };

  const checkYBoundaries = (nodes, yScale, minY, maxY, yPadding) => {
    nodes.forEach(n => {
      n.lblY = yScale.invert(getYBoundaryLimit(yScale(n.lblY), yScale, minY, maxY, yPadding));
    });
  };

  return [getScales, coordValX, coordValY, getYBoundaryLimit, checkYBoundaries];
};

export default useGetScales;
